<template>
  <div id="leaveapply">
      
    <el-form :model="form" ref="form" :rules="rules">
        <el-row :gutter="10" style="position:relative;left:-5px;">
          <!-- <el-col :span="24"> -->
           <el-form-item label="请假类别：" prop="leaveType">
               <el-select v-model="form.leaveType" placeholder="请选择"  size="medium">
                <el-option v-for="item in adjustdata" :key="item.value" :value="item.value" :label="item.text"></el-option>
              </el-select>
            </el-form-item>
          <!-- </el-col> -->
          
        </el-row>
        <el-row :gutter="20" v-for="(crpItem, index) in form.details" :key="index">
           <template>
                  <el-row>
                    <el-col :span="10" style="padding-left:0">
                     
                      <el-form-item
                        :prop="'details.' + index + '.daytime'"
                        label="请假日期："
                        :rules="{required: true,message: '请选择日期', trigger: 'change'}"
                      >
                        <el-select
                          v-model="crpItem.daytime"
                          size="medium" filterable clearable  @change="pos"
                          placeholder="请选择假期"
                          @focus="focus(index)"
                          @clear="crpItem.lessonsplandetailId='';"
                        >
                          <el-option
                            v-for="item in dayData"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                        <img src="@/assets/images/icon/close_1.png" @click="deleteItem(index)" style="position:relative;top:5px;" v-if="index>0">
                      </el-form-item>
                      
                    </el-col>
                    </el-row>
                    <el-row>
                    <el-col :span="10">
                      <el-form-item
                        :prop="'details.' + index + '.lessonsplandetailId'"
                         label="请假时段："
                        :rules="{required: true,message: '请选择时段', trigger: 'change'}"
                      >
                         <el-select
                          v-model="crpItem.lessonsplandetailId"
                          size="medium" filterable clearable  
                          placeholder="请选择时段"
                         
                          @change="poss"
                        >
                          <el-option
                            v-for="item in crpItem.timeData"
                            :key="item.lessId"
                            :label="item.label"
                            :value="item.lessId"
                          ></el-option>
                        </el-select>
                       
                      </el-form-item>
                      
                    </el-col>
                    </el-row>
                  </template>
        </el-row>
        <el-row :gutter="25">
            <el-col :span="8" style="margin-bottom:25px;padding-left:108.5px;">
                    <el-button @click.prevent="addCrpList">增加时段</el-button>
            </el-col>
        </el-row>
         <el-row :gutter="10">
            <!-- <el-col :span="24"> -->
                <el-form-item label="时长(小时)：" prop="hours" >
                <el-input v-model="form.hours" placeholder="选择时段后自动显示" maxlength="50" size="medium" readonly></el-input>
                </el-form-item>
            <!-- </el-col> -->
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="请假原因：" prop="reason">
              <el-input type="textarea" placeholder="请输入备注" v-model.trim="form.reason"></el-input>
              
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" @click="saveCampus" >提交</el-button>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
    export default {
  name: "Register",
  props: ["tabindex"],
  
  data() {
    return {
     index:"",
      userAuth:{},
      addVisible:false,
       rules: {
        leaveType: [{required: true, message: '请选择请假类型', trigger: 'blur'}],
       
      },
      loading:false,
      form : {
        id: null,
        leaveType: null,
        details:[
          {classId:"",lessonsplandetailId:"", timeData:[],daytime:""}
        ],
        hours:null,
        reason: null,
        userId:null,
        name:'',
        userType:2
      },
      dayData:[],
      timeData:[],
      ids:[],
      adjustdata:[],
    };
  },
  async mounted() {
    let me = this;
    me.$watch("tabindex", async function(val, oldval) {   
      if (val == '0') {
         me.ids=[];
          me.form = {
              id: null,
              leaveType: null,
              details:[
                {classId:"",lessonsplandetailId:"", daytime:"",timeData:[]}
              ],
              hours:null,
              reason: null,
              userId:null,
              name:'',
              userType:2
            };
             let userinfo = window.sessionStorage.getItem('userinfo');
              userinfo = JSON.parse(userinfo);
              me.form.userId=userinfo.id;
              me.form.name=userinfo.name;
            
            await me.getDay(); 
            await me.gettype();
          }
    })
  },
  methods: {
    pos(item){
     
      this.getarea(item);
    },
    deleteItem(index){
        this.ids.splice(index,1);
        //  this.form.details[index].classId=null;
        //  this.form.details[index].lessonsplandetailId=null;
         this.form.details.splice(index,1);
         this.gethours();     
    },
    focus(index){
      
      let me=this;
       this.index=index;    
    },
    poss(item){
      if(this.ids.indexOf(item)=='-1'){
           this.ids[this.index]=item;
      }
       
        this.timeData.forEach(items=>{
          if(items.id==item){
               this.form.details[this.index].classId=items.class_id;
          }
        })
        this.gethours();
    },
    async gethours(){
         let me = this;
         let param={
          ids:[],
        };
         this.ids.forEach(function(item,index){
            param.ids.push(item);
         })
        
        let res = await me.$team.leaveCountHours(param);
        if(res&&res['success']){
          res.content=res.content.toFixed(2);
          me.$set(me.form,'hours',res.content);
        }
    },
     addCrpList() {
      let me = this;
      me.form.details.push({
      classId:"",lessonsplandetailId:"",daytime:'', timeData:[],
      });
    },
    async gettype(){
      let me=this;
      let usertype = await me.$userService.querySysCode('tm','LeaveType');
          if (usertype && usertype.success) {
               me.adjustdata=[];
                 let obj=usertype.content.LeaveType;
              obj.forEach(function(item,index){
                 if(item.value=='2' || item.value =='4'|| item.value =='8'){
                   me.adjustdata.push(item);
                 }
               })
          }
    },
    async getDay(){
       let me = this;
        let param={
          userType:2,
        };
        let res = await me.$userService.leaveQueryTimestamp(param);
        if(res&&res['success']){
          me.dayData=[];
          res.content.forEach(i=>{
            i=i.slice(0, 10)
            let param={
              value:i,
              label:i,
              disabled:false
            }
             me.dayData.push(param)
          })   
        }
    },
    async getarea(item){
        let me = this;
        let param={
          userType:2,
          time:item
        };
        let res = await me.$userService.leaveQueryLeaveClass(param);
        if(res&&res['success']){
          me.timeData=res.content;
          me.form.details[me.index].timeData=[];
           me.$set(me.form.details[me.index],'lessonsplandetailId',null);
          res.content.forEach(function(item,index){
                item.label=item.periodInfo.startSchoolTime+'-'+item.periodInfo.endSchoolTime+'('+item.classInfo.name+')';
                item.lessId=item.id;
                 me.$set(me.form.details[me.index].timeData,index,item);
                 console.log(me.form.details[me.index].timeData)
          })
         
         
        }
    },
      saveCampus(){
        let me=this;
        me.$refs.form.validate(async valid => {
        if (valid) {
              let param={
                 id: null,
                leaveType: null,
                details:[{
                  "type":"1","data":[]
                }],
                hours:null,
                reason: null,
                userId:null,
                name:'',
                userType:2
              };
              param.id=me.form.id;
              param.leaveType=me.form.leaveType;
              param.hours=me.form.hours;
              param.reason=me.form.reason;
              param.userId=me.form.userId;
              param.userType=2;
              param.name=me.form.name;
             
              me.form.details.forEach((item)=>{
                let parm={
                  classId:item.classId,
                  lessonsplandetailId:item.lessonsplandetailId
                }
                param.details[0].data.push(parm);
              })
             let res = await me.$userService.leaveCreateOrUpdate(param);
            if(res&&res['success']){
                me.$message({
                    message:res.content,
                        type: 'success'
                })
                me.form.id=null;
                me.form.leaveType=null,
                me.form.details=[{classId:"",lessonsplandetailId:"",daytime:'',dataarea:"",timeData:[]}];
                me.form.reason=null;
                me.form.hours=null;
            }
          }
        })
      },
  },

};
</script>
<style lang="scss">
    #leaveapply{
        padding-left:50px;
    }
</style>



// WEBPACK FOOTER //
// src/components/attendance/child/ApplicationLeave.vue